import api from '../services/api';
import Swal from 'sweetalert2';

export default function Pacientes() {
  
  async function novaSugestao(cod_paciente) {
  // Busca sugestão existente
    let sugestao = null;
    try {
      const res = await api.get(`/terapiasugestao/${cod_paciente}`);
      sugestao = res.data || null;
    } catch (err) {
      console.warn('Nenhuma sugestão encontrada para este paciente');
    }

    Swal.fire({
      title: sugestao ? 'Editar Sugestão de Terapia' : 'Nova Sugestão de Terapia',
      html: `
        <form id="fSugestao" style="display:flex;flex-direction:column;gap:10px;text-align:left;">
          
          <!-- Linha 0 -->
        <div style="display:flex;gap:10px;">
            <label style="flex:1">Tipo de Terapia
              <select name="cod_tipo_terapia" class="swal2-input" required>
                <option value="1" ${sugestao?.cod_tipo_terapia == '1' ? 'selected' : ''}>Passivo</option>
                <option value="2" ${sugestao?.cod_tipo_terapia == '2' ? 'selected' : ''}>Ativo</option>
              </select>
            </label>            
          </div>

             <!-- Linha 1 -->
          <div style="display:flex;gap:10px;">
            <label style="flex:1">Angulos
              <input name="anguloinicial" type="number" step="0.1" class="swal2-input" value="${sugestao?.anguloinicial || '15'}" />
            </label>
            <label style="flex:1">Duração
              <input name="angulofinal" type="number" class="swal2-input" value="${sugestao?.angulofinal || '165'}" />
            </label>
          </div>

          <!-- Linha 1 -->
          <div style="display:flex;gap:10px;">
            <label style="flex:1">Rpm/Torque
              <input name="carga" type="number" step="0.1" class="swal2-input" value="${sugestao?.carga || '20'}" />
            </label>
            <label style="flex:1">Duração
              <input name="duracao" type="number" class="swal2-input" value="${sugestao?.duracao || '0'}" />
            </label>
          </div>

          <!-- Linha 2 -->
          <div style="display:flex;gap:10px;">
            <label style="flex:1">Frequência
              <input name="frequencia" type="number" class="swal2-input" value="${sugestao?.frequencia || '200'}" />
            </label>
            <label style="flex:1">Largura de Pulso
              <input name="largura_pulso" type="number" class="swal2-input" value="${sugestao?.largura_pulso || '200'}" />
            </label>
          </div>

          <!-- Linha 3 -->
          <div style="display:flex;gap:10px;">
            <label style="flex:1">Canal 1
              <input name="intensidade_canal_1" type="number" class="swal2-input" value="${sugestao?.intensidade_canal_1 || '20'}" />
            </label>
            <label style="flex:1">Canal 2
              <input name="intensidade_canal_2" type="number" class="swal2-input" value="${sugestao?.intensidade_canal_2 || '20'}" />
            </label>
            <label style="flex:1">Canal 3
              <input name="intensidade_canal_3" type="number" class="swal2-input" value="${sugestao?.intensidade_canal_3 || '20'}" />
            </label>
          </div>

          <!-- Linha 4 -->
          <div style="display:flex;gap:10px;">
            <label style="flex:1">Canal 4
              <input name="intensidade_canal_4" type="number" class="swal2-input" value="${sugestao?.intensidade_canal_4 || '20'}" />
            </label>
            <label style="flex:1">Canal 5
              <input name="intensidade_canal_5" type="number" class="swal2-input" value="${sugestao?.intensidade_canal_5 || '20'}" />
            </label>
            <label style="flex:1">Canal 6
              <input name="intensidade_canal_6" type="number" class="swal2-input" value="${sugestao?.intensidade_canal_6 || '20'}" />
            </label>
          </div>
        </form>
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Salvar',
      cancelButtonText: 'Cancelar',
      preConfirm: async () => {

        const usuario = JSON.parse(localStorage.getItem('usuario'));
        const codUsuario = usuario.cod_usuario;

        const fd = new FormData(document.getElementById('fSugestao'));
        const payload = Object.fromEntries(fd.entries());
        payload.cod_paciente = cod_paciente;
        payload.data = new Date().toISOString();
        payload.cod_usuario = codUsuario;
        try {

            await api.post('/terapiasugestao', payload);

          Swal.fire({ title: 'Sugestão salva!', icon: 'success', showConfirmButton: false, timer: 1500 });
        } catch (err) {
          Swal.showValidationMessage(err.response?.data?.message || 'Erro ao salvar sugestão');
          return false;
        }
      }
    });
  }

  const container = document.createElement('div');
  container.className = 'content';

  // Card de título
  const header = document.createElement('div');
  header.className = 'card';
  header.innerHTML = `<h2>Pacientes</h2>`;
  container.appendChild(header);

  // Card de ações
  const actions = document.createElement('div');
  actions.className = 'card inline';
  actions.innerHTML = `
    <input id="filtroPaciente" class="form-input" placeholder="Filtrar por nome..." />
    <button id="btnCarregarPaciente" class="btn btn-sm">Carregar</button>
    <button id="btnNovoPaciente" class="btn primary btn-sm">Novo</button>
  `;
  container.appendChild(actions);

  // Card da tabela
  const grid = document.createElement('div');
  grid.className = 'card';
  grid.innerHTML = `
    <table class="table">
      <thead>
        <tr>
          <th>Nome</th>
          <th>Peso</th>
          <th>Data Nasc.</th>
          <th>Total terapias</th>
          <th>Empresa</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody id="tbPacientes"></tbody>
    </table>
  `;
  container.appendChild(grid);

const formatDateBR = (dateString) => {

  if (!dateString) return '';
  try {

    // Caso ISO: 2026-09-01T00:00:00.000Z
    if (dateString.includes('T')) {
      const [datePart] = dateString.split('T'); // pega só "2026-09-01"
      const [year, month, day] = datePart.split('-');
      return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
    }

    // Caso com espaço: 2026-09-01 00:00:00
    if (dateString.includes(' ')) {
      const [datePart] = dateString.split(' ');
      const [year, month, day] = datePart.split('-');
      return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
    }
     // Caso simples: YYYY-MM-DD
    const partes = dateString.split('-');

    if (partes.length === 3) {
      const [year, month, day] = partes;
      return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
    }
    // Caso já esteja em dd/MM/yyyy
    const partesBR = dateString.split('/');
    if (partesBR.length === 3) {
      const [dia, mes, ano] = partesBR;
      return `${dia.padStart(2, '0')}/${mes.padStart(2, '0')}/${ano}`;
    }

    // Fallback: tenta deixar o JS interpretar
    const d = new Date(dateString);
    if (!isNaN(d.getTime())) {
      return d.toLocaleDateString('pt-BR');
    }
    return dateString;
  } catch (err) {
    console.error('Erro ao formatar data:', err);
    return dateString;
  }

};

  // Função de carregar lista
  async function carregar() {
    const filtroInput = container.querySelector('#filtroPaciente');
    const filtro = filtroInput ? filtroInput.value : '';
    try {
      const res = await api.get('/pacientes', { params: { filtro } });
      const tbody = grid.querySelector('#tbPacientes');
      tbody.innerHTML = res.data.map(p => `
        <tr>
          <td>${p.nome}</td>
          <td>${p.peso || ''}</td>
          <td>${p.data_nasc ? formatDateBR(p.data_nasc) : ''}</td>
          <td>${p.total_terapias || '0'}</td>
          <td>${p.empresa_descricao || ''}</td>
          <td>
            <button class="btn btn-sm edit" data-id="${p.cod_paciente}">
              <i class="fa-solid fa-pen"></i> Editar
            </button>
            <button class="btn btn-sm btn-sm link suggest" data-id="${p.cod_paciente}">
              <i class="fa-solid fa-link"></i> Sugestão Terapia
            </button>
            <button class="btn btn-sm danger del" data-id="${p.cod_paciente}">
              <i class="fa-solid fa-trash"></i> Excluir
            </button>
          </td>
        </tr>
      `).join('');
      bind();
    } catch (err) {
      console.error('Erro ao carregar pacientes:', err);
    }
  }

  // Bind dos botões
  function bind() {
    grid.querySelectorAll('.edit').forEach(b =>
      b.onclick = () => editar(b.getAttribute('data-id'))
    );
    grid.querySelectorAll('.del').forEach(b =>
      b.onclick = () => excluir(b.getAttribute('data-id'))
    );
    grid.querySelectorAll('.suggest').forEach(b =>
      b.onclick = () => novaSugestao(b.getAttribute('data-id'))
    );

  }

  // Excluir paciente
  async function excluir(id) {
    const result = await Swal.fire({
      title: 'Excluir paciente?',
      text: 'Essa ação não poderá ser desfeita!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sim, excluir',
      cancelButtonText: 'Cancelar'
    });
    if (!result.isConfirmed) return;
    await api.delete(`/pacientes/${id}`);
    Swal.fire({ title: 'Excluído!', icon: 'success', showConfirmButton: false, timer: 1500 });
    carregar();
  }

  // Formulário de edição/criação
  async function editar(id) {
    const pacientes = (await api.get('/pacientes')).data;
    const paciente = pacientes.find(x => x.cod_paciente === id);
    const empresas = (await api.get('/empresas')).data;

    console.log('Paciente selecionado:', paciente);
    console.log('Empresas disponíveis:', empresas);
    console.log('cod_empresa do paciente:', paciente?.cod_empresa);
   
    Swal.fire({
      title: id ? 'Editar Paciente' : 'Novo Paciente',
      html: `
        <form id="fPaciente" style="display:flex;flex-direction:column;gap:6px;text-align:left;">
          <label>Nome
            <input name="nome" value="${paciente?.nome || ''}" required class="swal2-input" />
          </label>
          <label>Peso
            <input name="peso" type="number" value="${paciente?.peso || ''}" class="swal2-input" />
          </label>
          <label>Data Nascimento
            <input name="data_nasc" type="date" value="${paciente?.data_nasc ? paciente.data_nasc.split('T')[0] : ''}" class="swal2-input" />
          </label>
          <label>Empresa
           <select name="cod_empresa" required class="swal2-input">
            ${empresas.map(e => `
              <option value="${e.cod_empresa}" 
                ${String(paciente?.cod_empresa).trim().toLowerCase() === String(e.cod_empresa).trim().toLowerCase() ? 'selected' : ''}>
                ${e.descricao}
              </option>
            `).join('')}
          </select>
          </label>
        </form>
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Salvar',
      cancelButtonText: 'Cancelar',
      preConfirm: async () => {
        const fd = new FormData(document.getElementById('fPaciente'));
        const payload = Object.fromEntries(fd.entries());
        try {
          if (id) {
            await api.put(`/pacientes/${id}`, payload);
          } else {
            await api.post('/pacientes', payload);
          }
          carregar();
        } catch (err) {
          Swal.showValidationMessage(err.response?.data?.message || 'Erro ao salvar paciente');
          return false;
        }
      }
    });
  }

  // Botões principais
  actions.querySelector('#btnCarregarPaciente').onclick = carregar;
  actions.querySelector('#btnNovoPaciente').onclick = () => editar();

  carregar();
  return container;
}
